import { GridBaseDataProvider } from '../../../grid/GridBaseDataProvider';
import { Column, ColumnKeys, SetFiltersRequest, GetDataGridItemsResponse, ExclusionItem } from '../types';
import { GetRowsRequest, GetSummaryRequest, GetSummaryResponse, UpdateSettingsRequest, UpdateSettingsResponse } from '../../../grid/types/common';
import { sanitizeObject } from '../../../utils/sanitization.utils';
import { v4 as uuidv4 } from 'uuid';
import { ConsoleRequest, DataProviderType } from '../../../utils/request';
import { RpcAction, RpcExclusionItemsMethod } from '../../exclusionListItemsEditPanel/types';
import { getExclusionItemsRecords, getPayloadForReadRecords } from '../helpers';
import { translateFn } from '../../../utils/translator.helper';

export class ExclusionItemGridDataProvider extends GridBaseDataProvider<Column, ColumnKeys> {
  private localData: Array<ExclusionItem> = [];
  private remoteData: Array<ExclusionItem> = [];
  private remoteTotalData = 0;
  private isRemoteDataLoaded = false;
  private allData: Array<ExclusionItem> = [];
  private listId?: string;

  constructor(public dependencies: any) {
    super();
  }

  public addItem(item) {
    item.id = uuidv4();
    item.actions = 'actions';
    this.localData.unshift(item);
  }

  public deleteItem(id) {
    this.localData = this.localData.filter(item => item.id !== id);
  }

  public getItems() {
    return this.localData;
  }

  public resetGrid() {
    this.localData = [];
    this.allData = [];
    this.remoteData = [];
    this.remoteTotalData = 0;
    this.isRemoteDataLoaded = false;
  }

  public async readRecords(request): Promise<any> {
    const readRequestResponse = await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.ENDPOINTS,
      payload: getPayloadForReadRecords(request),
      endpoint: RpcAction.EXCLUSION_ITEMS,
      method: RpcExclusionItemsMethod.READ_RECORDS,
    });

    return getExclusionItemsRecords(readRequestResponse);
  }

  async getSummary(request: GetSummaryRequest<ColumnKeys>): Promise<GetSummaryResponse> {
    if (request.extraParams.listId && !this.isRemoteDataLoaded) {
      const response = await this.readRecords(request);
      this.remoteData = response.data;
      this.remoteTotalData = response.total;
      this.isRemoteDataLoaded = true;
    }
    const summary = this.localData.length + this.remoteTotalData;
    this.allData = [];
    this.allData.push(...this.localData, ...this.remoteData);

    return sanitizeObject({
      summary: translateFn('{noOfItems} items', {
        noOfItems: summary,
      }),
      numItems: summary,
    });
  }

  async getRows(request: GetRowsRequest<Column, ColumnKeys>): Promise<GetDataGridItemsResponse> {
    let data: Array<ExclusionItem>;

    if (!request.numRecordsToSkip) {
      data = this.allData;
    } else {
      const response = await this.readRecords(request)
      data = response.data;
    }

    return sanitizeObject({ rawEvents: data });
  }

  async setFilters(request: SetFiltersRequest): Promise<{} | undefined> {
    return;
  }

  async updateSettings(request: UpdateSettingsRequest<Column>): Promise<UpdateSettingsResponse> {
    return {};
  }
}
